module.exports = __webpack_public_path__ + "assets/img/free_25.562365ec.png";